import { css } from 'styled-components';
import { ScreenWidth } from '../screenWidth';
export const minWidth = (size, styles) => css `
  @media (min-width: ${size}) {
    ${styles}
  }
`;
export const maxWidth = (size, styles) => css `
  @media (max-width: ${size}) {
    ${styles}
  }
`;
export const minWidthExtraSmall = (styles) => minWidth(ScreenWidth.EXTRA_SMALL, styles);
export const minWidthSmall = (styles) => minWidth(ScreenWidth.SMALL, styles);
export const minWidthMedium = (styles) => minWidth(ScreenWidth.MEDIUM, styles);
export const minWidthLarge = (styles) => minWidth(ScreenWidth.LARGE, styles);
export const minWidthExtraLarge = (styles) => minWidth(ScreenWidth.EXTRA_LARGE, styles);
export const maxWidthExtraSmall = (styles) => maxWidth(ScreenWidth.EXTRA_SMALL, styles);
export const maxWidthSmall = (styles) => maxWidth(ScreenWidth.SMALL, styles);
export const maxWidthMedium = (styles) => maxWidth(ScreenWidth.MEDIUM, styles);
export const maxWidthLarge = (styles) => maxWidth(ScreenWidth.LARGE, styles);
export const maxWidthExtraLarge = (styles) => maxWidth(ScreenWidth.EXTRA_LARGE, styles);
//# sourceMappingURL=media.js.map